import type { Permission } from '@/constants/permissions';
import { useAuthStore } from '@/store/auth.store';
import type { Role } from '@/types/auth';
import { hasAnyPermission, hasAnyRole } from '@/utils/rbac';

export function useAuth() {
  const status = useAuthStore((state) => state.status);
  const user = useAuthStore((state) => state.user);
  const isLoading = useAuthStore((state) => state.isLoading);
  const error = useAuthStore((state) => state.error);
  const login = useAuthStore((state) => state.login);
  const logout = useAuthStore((state) => state.logout);

  return {
    user,
    isAuthenticated: status === 'authenticated',
    isInitializing: status === 'idle',
    isLoading,
    error,
    login,
    logout,
    hasRole: (roles: Role[]) => hasAnyRole(user, roles),
    hasPermission: (permissions: Permission[]) => hasAnyPermission(user, permissions),
  };
}
